import { render } from "./ConfirmInstanceDeleteDialog.vue?vue&type=template&id=48f5b04f"
import script from "./ConfirmInstanceDeleteDialog.vue?vue&type=script&lang=js"
export * from "./ConfirmInstanceDeleteDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__